export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom :"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez fournir un nouveau nom pour l'actif"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ce nom vous aidera à identifier plus facilement le portefeuille dans votre liste d'actifs."])}
}